export default __webpack_public_path__ + "static/media/smoke.55db43c4.webp";